import React from 'react';
import { Layout, Row, Col, Typography, Space, Button } from 'antd';
import { Link } from 'react-router-dom';

const { Footer: AntFooter } = Layout;
const { Title, Text } = Typography;

function Footer() {
  return (
    <AntFooter
      style={{
        backgroundColor: '#141414',
        color: 'white',
        padding: '48px 16px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <Row gutter={[32, 32]}>
          <Col xs={24} sm={8}>
            <Title level={5} style={{ color: 'white', marginBottom: 16 }}>
              About Us
            </Title>
            <Text style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
              Discover your city&apos;s hidden gems, local events, and curated experiences.
            </Text>
          </Col>
          <Col xs={24} sm={8}>
            <Title level={5} style={{ color: 'white', marginBottom: 16 }}>
              Quick Links
            </Title>
            <Space direction="vertical">
              <Link to="/places" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                Places
              </Link>
              <Link to="/events" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                Events
              </Link>
              <Link to="/tours" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                Tours
              </Link>
            </Space>
          </Col>
          <Col xs={24} sm={8}>
            <Title level={5} style={{ color: 'white', marginBottom: 16 }}>
              Contact
            </Title>
            <Space direction="vertical" style={{ color: 'rgb(255, 255, 255)' }}>
              <Text style={{ color: 'rgba(255, 255, 255, 0.65)' }}>Email: jon@yo.city</Text>
              <Button onClick={() => (window.location.href = '/admin')}>Admin</Button>
            </Space>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: 32 }}>
          <Col>
            <Text style={{ color: 'rgba(255, 255, 255, 0.45)' }}>
              Powered By © {new Date().getFullYear()} <a href="https://yo.city">YoCity</a>. All
              rights reserved.
            </Text>
          </Col>
        </Row>
      </div>
    </AntFooter>
  );
}

export default Footer;
